import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { translate } from 'services/i18nService';
import ThemeService from 'themes/ThemeService';

import styles from './ChatNotificationsTypes.css';


function BoostNotification({ message, roomName }) {
  const { boostUniqueViewers, senderOriginalUsername } = message;

  let username = senderOriginalUsername;
  if (senderOriginalUsername.includes('guest')) {
    username = translate('v2profile.gift.sender.guest');
  }

  let defaultBoostText = undefined;
  const isBroadcasterBoosted = username?.toLowerCase() === roomName?.toLowerCase();
  const isAnonBoost = isBroadcasterBoosted || parseInt(message.anonymous, 10) === 1;
  if (isAnonBoost) {
    defaultBoostText = translate('v2broadcast.boost.anonymous', { 0: roomName });
  } else {
    defaultBoostText = translate('strings.boost.boost.start', {
      0: username,
      1: roomName,
    });
  }

  let anonBoostText = undefined;
  if (isAnonBoost) {
    anonBoostText = translate(
      'v2broadcast.boost.ended.anonymous',
      {
        0: `<span class=${styles.textBlink}>${boostUniqueViewers}`,
        1: '</span>',
      }
    );
  } else {
    anonBoostText = translate(
      'strings.boost.start.v2',
      {
        0: username,
        1: `<span class=${styles.textBlink}>${boostUniqueViewers}`,
        2: '</span>',
      }
    );
  }

  return (
    <div className={styles.boostNotification}>
      {boostUniqueViewers !== undefined ? (
        <Fragment>
          <img
            alt=""
            className={styles.boostEndImg}
            src={ThemeService.theme.boost.icon}
          />
          <div className={styles.text}>
            {anonBoostText}
          </div>
        </Fragment>
      ) : (
        <Fragment>
          <img
            alt=""
            className={styles.boostStartImg}
            src={ThemeService.theme.boost.icon}
          />
          <div className={styles.text}>
            {defaultBoostText}
          </div>
        </Fragment>
      )}
    </div>
  );
}

BoostNotification.propTypes = {
  message: PropTypes.object.isRequired,
  roomName: PropTypes.string.isRequired,
};

export default BoostNotification;
